import { Box } from "@mui/material";
import moment from "moment";
import React from "react";
import { CampaignStatus } from "schemas/dashboard";

interface Props {
  status: CampaignStatus;
  startDate?: string;
}

const statusMap: Record<
  CampaignStatus,
  { label: string; color: string; bg: string; dot: string }
> = {
  [CampaignStatus.in_progress]: {
    label: "In Progress",
    color: "#1e40af",
    bg: "#dbeafe",
    dot: "#3b82f6",
  },
  [CampaignStatus.complete]: {
    label: "Complete",
    color: "#166534",
    bg: "#dcfce7",
    dot: "#22c55e",
  },
  [CampaignStatus.pending_approval]: {
    label: "Pending",
    color: "#854d0e",
    bg: "#fef9c3",
    dot: "#eab308",
  },
  [CampaignStatus.draft]: {
    label: "Draft",
    color: "#713f12",
    bg: "#fef3c7",
    dot: "#f59e0b",
  },
  [CampaignStatus.expired]: {
    label: "Expired",
    color: "#991b1b",
    bg: "#fee2e2",
    dot: "#ef4444",
  },
};

export const CampaignStatusChip: React.FC<Props> = ({ status, startDate }) => {
  const differenceInDays = (start: string) => {
    const today = moment().format("YYYY-MM-DD");
    const diff = moment(start).diff(today, "days") + 1;
    if (diff < 1) return "Expiring today!";
    if (diff === 1) return "Expiring tomorrow!";
    return `Expiring in ${diff} days`;
  };

  const { label, color, bg, dot } = statusMap[status];
  const displayLabel =
    startDate && status === CampaignStatus.pending_approval
      ? differenceInDays(startDate)
      : label;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: 10,
        backgroundColor: bg,
        color,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: "nowrap",
        lineHeight: 1.6,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: dot,
          flexShrink: 0,
        }}
      />
      {displayLabel}
    </Box>
  );
};
